<h1 class="page-title">Verify Credentials</h1>
<div class="col-wrap">
  <app-directory [showAllPractitioners]="true"></app-directory>
</div>
